import { Component } from '@angular/core';

@Component({
    selector: 'pace-authors-main',
    templateUrl: './main.component.html',
    styleUrl: './main.component.scss',
})
export class MainComponent {}
